import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Divider, Segment, Icon, Button } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { reportClientError } from "../../utils/clientErrors";

const Ko = ({ datiNoleggio, lang, codiceNoleggio, orderId }) => {
  const history = useHistory();

  // Il cliente e' tornato dal gateway con esito negativo
  useEffect(() => {
    reportClientError(
      codiceNoleggio,
      "pagina_ko",
      "Cliente tornato dal gateway con esito negativo",
      orderId
    );
  }, [codiceNoleggio, orderId]);

  return (
    <div className="ko">
      <Segment color="red">
        <h2>TRANSAZIONE NON RIUSCITA</h2>
        <Divider></Divider>
        <p>Oops... Qualcosa non ha funzionato...</p>
        {/* <div onClick={history.push(`/${lang}/${datiNoleggio.codiceNoleggio}`)}> */}
        <Icon name="times circle" size="massive" color="red" />
        {/* </div>  */}
      </Segment>
      <Button
        primary
        onClick={() => {
          history.push(`/${lang}/${datiNoleggio.codiceNoleggio}`);
          window.scrollTo(0, 0);
        }}
      >
        TORNA ALLO SHOP
      </Button>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    isLoading: state.apiReducer.apiCalls > 0,
    datiNoleggio: state.shopReducer.datiNoleggio,
    lang: state.shopReducer.lingua,
    codiceNoleggio: ownProps.match.params.codiceNoleggio,
    orderId: ownProps.match.params.codiceordine,
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Ko);
